// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ldTn4","buttonText":"styles_buttonText__3KCYY","buttonArrow":"styles_buttonArrow__23qTW"};